import React from 'react';
import ReactDOM from 'react-dom/client';
import StaffMpdSelect from './modules/donate/StaffMpdSelect';
import "../app/sentryInstrumentReact";

const staffMpdSelectDiv = document.getElementById('selected-staff-member-details');
if (staffMpdSelectDiv !== null) {
  const selectDiv = ReactDOM.createRoot(staffMpdSelectDiv);
  selectDiv.render(
    <>
      <StaffMpdSelect />
    </>
  );  
}